var Mt = Object.defineProperty;
var Pt = (i, n, e) => n in i ? Mt(i, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[n] = e;
var D = (i, n, e) => (Pt(i, typeof n != "symbol" ? n + "" : n, e), e);
import * as T from "react";
import Ve from "react";
import { cn as ce, Button as $e } from "@spiaggeit/spit-ui";
import { DateTime as H } from "luxon";
import { isSameDay as Tt, getCalendarsByPeriod as Rt } from "./dateUtils.js";
var ue = { exports: {} }, z = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var je;
function Lt() {
  return je || (je = 1, process.env.NODE_ENV !== "production" && function() {
    var i = Ve, n = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), m = Symbol.for("react.lazy"), M = Symbol.for("react.offscreen"), _ = Symbol.iterator, j = "@@iterator";
    function ee(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = _ && t[_] || t[j];
      return typeof s == "function" ? s : null;
    }
    var A = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function P(t) {
      {
        for (var s = arguments.length, d = new Array(s > 1 ? s - 1 : 0), g = 1; g < s; g++)
          d[g - 1] = arguments[g];
        U("error", t, d);
      }
    }
    function U(t, s, d) {
      {
        var g = A.ReactDebugCurrentFrame, v = g.getStackAddendum();
        v !== "" && (s += "%s", d = d.concat([v]));
        var x = d.map(function(y) {
          return String(y);
        });
        x.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, x);
      }
    }
    var Ge = !1, Ke = !1, Ze = !1, Xe = !1, Qe = !1, he;
    he = Symbol.for("react.module.reference");
    function et(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === r || t === o || Qe || t === a || t === h || t === p || Xe || t === M || Ge || Ke || Ze || typeof t == "object" && t !== null && (t.$$typeof === m || t.$$typeof === f || t.$$typeof === c || t.$$typeof === l || t.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === he || t.getModuleId !== void 0));
    }
    function tt(t, s, d) {
      var g = t.displayName;
      if (g)
        return g;
      var v = s.displayName || s.name || "";
      return v !== "" ? d + "(" + v + ")" : d;
    }
    function pe(t) {
      return t.displayName || "Context";
    }
    function N(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case r:
          return "Fragment";
        case e:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case h:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return pe(s) + ".Consumer";
          case c:
            var d = t;
            return pe(d._context) + ".Provider";
          case u:
            return tt(t, t.render, "ForwardRef");
          case f:
            var g = t.displayName || null;
            return g !== null ? g : N(t.type) || "Memo";
          case m: {
            var v = t, x = v._payload, y = v._init;
            try {
              return N(y(x));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Y = Object.assign, V = 0, ge, fe, be, me, ye, ve, ke;
    function we() {
    }
    we.__reactDisabledLog = !0;
    function rt() {
      {
        if (V === 0) {
          ge = console.log, fe = console.info, be = console.warn, me = console.error, ye = console.group, ve = console.groupCollapsed, ke = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: we,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        V++;
      }
    }
    function nt() {
      {
        if (V--, V === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Y({}, t, {
              value: ge
            }),
            info: Y({}, t, {
              value: fe
            }),
            warn: Y({}, t, {
              value: be
            }),
            error: Y({}, t, {
              value: me
            }),
            group: Y({}, t, {
              value: ye
            }),
            groupCollapsed: Y({}, t, {
              value: ve
            }),
            groupEnd: Y({}, t, {
              value: ke
            })
          });
        }
        V < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = A.ReactCurrentDispatcher, re;
    function q(t, s, d) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch (v) {
            var g = v.stack.trim().match(/\n( *(at )?)/);
            re = g && g[1] || "";
          }
        return `
` + re + t;
      }
    }
    var ne = !1, J;
    {
      var at = typeof WeakMap == "function" ? WeakMap : Map;
      J = new at();
    }
    function xe(t, s) {
      if (!t || ne)
        return "";
      {
        var d = J.get(t);
        if (d !== void 0)
          return d;
      }
      var g;
      ne = !0;
      var v = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var x;
      x = te.current, te.current = null, rt();
      try {
        if (s) {
          var y = function() {
            throw Error();
          };
          if (Object.defineProperty(y.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(y, []);
            } catch (O) {
              g = O;
            }
            Reflect.construct(t, [], y);
          } else {
            try {
              y.call();
            } catch (O) {
              g = O;
            }
            t.call(y.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (O) {
            g = O;
          }
          t();
        }
      } catch (O) {
        if (O && g && typeof O.stack == "string") {
          for (var b = O.stack.split(`
`), R = g.stack.split(`
`), E = b.length - 1, C = R.length - 1; E >= 1 && C >= 0 && b[E] !== R[C]; )
            C--;
          for (; E >= 1 && C >= 0; E--, C--)
            if (b[E] !== R[C]) {
              if (E !== 1 || C !== 1)
                do
                  if (E--, C--, C < 0 || b[E] !== R[C]) {
                    var L = `
` + b[E].replace(" at new ", " at ");
                    return t.displayName && L.includes("<anonymous>") && (L = L.replace("<anonymous>", t.displayName)), typeof t == "function" && J.set(t, L), L;
                  }
                while (E >= 1 && C >= 0);
              break;
            }
        }
      } finally {
        ne = !1, te.current = x, nt(), Error.prepareStackTrace = v;
      }
      var B = t ? t.displayName || t.name : "", Oe = B ? q(B) : "";
      return typeof t == "function" && J.set(t, Oe), Oe;
    }
    function it(t, s, d) {
      return xe(t, !1);
    }
    function ot(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function G(t, s, d) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return xe(t, ot(t));
      if (typeof t == "string")
        return q(t);
      switch (t) {
        case h:
          return q("Suspense");
        case p:
          return q("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            return it(t.render);
          case f:
            return G(t.type, s, d);
          case m: {
            var g = t, v = g._payload, x = g._init;
            try {
              return G(x(v), s, d);
            } catch {
            }
          }
        }
      return "";
    }
    var K = Object.prototype.hasOwnProperty, De = {}, Ee = A.ReactDebugCurrentFrame;
    function Z(t) {
      if (t) {
        var s = t._owner, d = G(t.type, t._source, s ? s.type : null);
        Ee.setExtraStackFrame(d);
      } else
        Ee.setExtraStackFrame(null);
    }
    function st(t, s, d, g, v) {
      {
        var x = Function.call.bind(K);
        for (var y in t)
          if (x(t, y)) {
            var b = void 0;
            try {
              if (typeof t[y] != "function") {
                var R = Error((g || "React class") + ": " + d + " type `" + y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[y] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw R.name = "Invariant Violation", R;
              }
              b = t[y](s, y, g, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (E) {
              b = E;
            }
            b && !(b instanceof Error) && (Z(v), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", g || "React class", d, y, typeof b), Z(null)), b instanceof Error && !(b.message in De) && (De[b.message] = !0, Z(v), P("Failed %s type: %s", d, b.message), Z(null));
          }
      }
    }
    var lt = Array.isArray;
    function ae(t) {
      return lt(t);
    }
    function dt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, d = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return d;
      }
    }
    function ct(t) {
      try {
        return Ce(t), !1;
      } catch {
        return !0;
      }
    }
    function Ce(t) {
      return "" + t;
    }
    function Se(t) {
      if (ct(t))
        return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", dt(t)), Ce(t);
    }
    var $ = A.ReactCurrentOwner, ut = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Me, Pe, ie;
    ie = {};
    function ht(t) {
      if (K.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function pt(t) {
      if (K.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function gt(t, s) {
      if (typeof t.ref == "string" && $.current && s && $.current.stateNode !== s) {
        var d = N($.current.type);
        ie[d] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', N($.current.type), t.ref), ie[d] = !0);
      }
    }
    function ft(t, s) {
      {
        var d = function() {
          Me || (Me = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        d.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: d,
          configurable: !0
        });
      }
    }
    function bt(t, s) {
      {
        var d = function() {
          Pe || (Pe = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        d.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: d,
          configurable: !0
        });
      }
    }
    var mt = function(t, s, d, g, v, x, y) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: d,
        props: y,
        // Record the component responsible for creating this element.
        _owner: x
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: g
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function yt(t, s, d, g, v) {
      {
        var x, y = {}, b = null, R = null;
        d !== void 0 && (Se(d), b = "" + d), pt(s) && (Se(s.key), b = "" + s.key), ht(s) && (R = s.ref, gt(s, v));
        for (x in s)
          K.call(s, x) && !ut.hasOwnProperty(x) && (y[x] = s[x]);
        if (t && t.defaultProps) {
          var E = t.defaultProps;
          for (x in E)
            y[x] === void 0 && (y[x] = E[x]);
        }
        if (b || R) {
          var C = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && ft(y, C), R && bt(y, C);
        }
        return mt(t, b, R, v, g, $.current, y);
      }
    }
    var oe = A.ReactCurrentOwner, Te = A.ReactDebugCurrentFrame;
    function I(t) {
      if (t) {
        var s = t._owner, d = G(t.type, t._source, s ? s.type : null);
        Te.setExtraStackFrame(d);
      } else
        Te.setExtraStackFrame(null);
    }
    var se;
    se = !1;
    function le(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Re() {
      {
        if (oe.current) {
          var t = N(oe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function vt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), d = t.lineNumber;
          return `

Check your code at ` + s + ":" + d + ".";
        }
        return "";
      }
    }
    var Le = {};
    function kt(t) {
      {
        var s = Re();
        if (!s) {
          var d = typeof t == "string" ? t : t.displayName || t.name;
          d && (s = `

Check the top-level render call using <` + d + ">.");
        }
        return s;
      }
    }
    function _e(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var d = kt(s);
        if (Le[d])
          return;
        Le[d] = !0;
        var g = "";
        t && t._owner && t._owner !== oe.current && (g = " It was passed a child from " + N(t._owner.type) + "."), I(t), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, g), I(null);
      }
    }
    function Ae(t, s) {
      {
        if (typeof t != "object")
          return;
        if (ae(t))
          for (var d = 0; d < t.length; d++) {
            var g = t[d];
            le(g) && _e(g, s);
          }
        else if (le(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var v = ee(t);
          if (typeof v == "function" && v !== t.entries)
            for (var x = v.call(t), y; !(y = x.next()).done; )
              le(y.value) && _e(y.value, s);
        }
      }
    }
    function wt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var d;
        if (typeof s == "function")
          d = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === f))
          d = s.propTypes;
        else
          return;
        if (d) {
          var g = N(s);
          st(d, t.props, "prop", g, t);
        } else if (s.PropTypes !== void 0 && !se) {
          se = !0;
          var v = N(s);
          P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", v || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function xt(t) {
      {
        for (var s = Object.keys(t.props), d = 0; d < s.length; d++) {
          var g = s[d];
          if (g !== "children" && g !== "key") {
            I(t), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", g), I(null);
            break;
          }
        }
        t.ref !== null && (I(t), P("Invalid attribute `ref` supplied to `React.Fragment`."), I(null));
      }
    }
    function Ne(t, s, d, g, v, x) {
      {
        var y = et(t);
        if (!y) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var R = vt(v);
          R ? b += R : b += Re();
          var E;
          t === null ? E = "null" : ae(t) ? E = "array" : t !== void 0 && t.$$typeof === n ? (E = "<" + (N(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : E = typeof t, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", E, b);
        }
        var C = yt(t, s, d, v, x);
        if (C == null)
          return C;
        if (y) {
          var L = s.children;
          if (L !== void 0)
            if (g)
              if (ae(L)) {
                for (var B = 0; B < L.length; B++)
                  Ae(L[B], t);
                Object.freeze && Object.freeze(L);
              } else
                P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ae(L, t);
        }
        return t === r ? xt(C) : wt(C), C;
      }
    }
    function Dt(t, s, d) {
      return Ne(t, s, d, !0);
    }
    function Et(t, s, d) {
      return Ne(t, s, d, !1);
    }
    var Ct = Et, St = Dt;
    z.Fragment = r, z.jsx = Ct, z.jsxs = St;
  }()), z;
}
var W = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fe;
function _t() {
  if (Fe)
    return W;
  Fe = 1;
  var i = Ve, n = Symbol.for("react.element"), e = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, a = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(l, u, h) {
    var p, f = {}, m = null, M = null;
    h !== void 0 && (m = "" + h), u.key !== void 0 && (m = "" + u.key), u.ref !== void 0 && (M = u.ref);
    for (p in u)
      r.call(u, p) && !o.hasOwnProperty(p) && (f[p] = u[p]);
    if (l && l.defaultProps)
      for (p in u = l.defaultProps, u)
        f[p] === void 0 && (f[p] = u[p]);
    return { $$typeof: n, type: l, key: m, ref: M, props: f, _owner: a.current };
  }
  return W.Fragment = e, W.jsx = c, W.jsxs = c, W;
}
process.env.NODE_ENV === "production" ? ue.exports = _t() : ue.exports = Lt();
var k = ue.exports, S;
let w = (S = class extends Date {
  constructor(e = null, r = "YYYY-MM-DD", a = "en-US") {
    super(S.parseDateTime(e, r, a));
    D(this, "lang");
    this.lang = a;
  }
  static parseDateTime(e, r = "YYYY-MM-DD", a = "en-US") {
    if (!e)
      return new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
    if (e instanceof S)
      return e.toJSDate();
    if (e instanceof Date)
      return e;
    if (/^-?\d{10,}$/.test(String(e)))
      return new Date(Number(e));
    if (typeof e == "string") {
      const o = [];
      let c = null;
      for (; (c = S.regex.exec(r)) != null; )
        c[1] !== "\\" && o.push(c);
      if (o.length) {
        const l = { year: null, month: null, shortMonth: null, longMonth: null, day: null, hour: 0, minute: 0, second: 0, ampm: null, value: "" };
        o[0].index > 0 && (l.value += ".*?");
        for (const [h, p] of Object.entries(o)) {
          const f = Number(h), { group: m, pattern: M } = S.formatPatterns(p[0], a);
          l[m] = f + 1, l.value += M, l.value += ".*?";
        }
        const u = new RegExp(`^${l.value}$`);
        if (u.test(e)) {
          const h = u.exec(e), p = Number(h[l.year]);
          let f = null;
          l.month ? f = Number(h[l.month]) - 1 : l.shortMonth ? f = S.shortMonths(a).indexOf(h[l.shortMonth]) : l.longMonth && (f = S.longMonths(a).indexOf(h[l.longMonth]));
          const m = Number(h[l.day]) || 1, M = Number(h[l.hour]);
          let _ = Number.isNaN(M) ? 0 : M;
          const j = Number(h[l.minute]), ee = Number.isNaN(j) ? 0 : j, A = Number(h[l.second]), P = Number.isNaN(A) ? 0 : A, U = h[l.ampm];
          return U && U === "PM" && (_ += 12, _ === 24 && (_ = 0)), new Date(p, f, m, _, ee, P, 0);
        }
      }
    }
    return new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0));
  }
  static shortMonths(e) {
    return S.MONTH_JS.map((r) => new Date(2019, r).toLocaleString(e, { month: "short" }));
  }
  static longMonths(e) {
    return S.MONTH_JS.map((r) => new Date(2019, r).toLocaleString(e, { month: "long" }));
  }
  static formatPatterns(e, r) {
    switch (e) {
      case "YY":
      case "YYYY":
        return { group: "year", pattern: `(\\d{${e.length}})` };
      case "M":
        return { group: "month", pattern: "(\\d{1,2})" };
      case "MM":
        return { group: "month", pattern: "(\\d{2})" };
      case "MMM":
        return { group: "shortMonth", pattern: `(${S.shortMonths(r).join("|")})` };
      case "MMMM":
        return { group: "longMonth", pattern: `(${S.longMonths(r).join("|")})` };
      case "D":
        return { group: "day", pattern: "(\\d{1,2})" };
      case "DD":
        return { group: "day", pattern: "(\\d{2})" };
      case "h":
      case "H":
        return { group: "hour", pattern: "(\\d{1,2})" };
      case "hh":
      case "HH":
        return { group: "hour", pattern: "(\\d{2})" };
      case "m":
        return { group: "minute", pattern: "(\\d{1,2})" };
      case "mm":
        return { group: "minute", pattern: "(\\d{2})" };
      case "s":
        return { group: "second", pattern: "(\\d{1,2})" };
      case "ss":
        return { group: "second", pattern: "(\\d{2})" };
      case "a":
      case "A":
        return { group: "ampm", pattern: "(AM|PM|am|pm)" };
    }
  }
  getWeek(e) {
    const r = new Date(this.midnight_ts(this)), a = (this.getDay() + (7 - e)) % 7;
    r.setDate(r.getDate() - a);
    const o = r.getTime();
    return r.setMonth(0, 1), r.getDay() !== e && r.setMonth(0, 1 + (4 - r.getDay() + 7) % 7), 1 + Math.ceil((o - r.getTime()) / 6048e5);
  }
  clone() {
    return new S(this);
  }
  toJSDate() {
    return new Date(this);
  }
  inArray(e, r = "[]") {
    return e.some((a) => a instanceof Array ? this.isBetween(a[0], a[1], r) : this.isSame(a, "day"));
  }
  isBetween(e, r, a = "()") {
    switch (a) {
      default:
      case "()":
        return this.midnight_ts(this) > this.midnight_ts(e) && this.midnight_ts(this) < this.midnight_ts(r);
      case "[)":
        return this.midnight_ts(this) >= this.midnight_ts(e) && this.midnight_ts(this) < this.midnight_ts(r);
      case "(]":
        return this.midnight_ts(this) > this.midnight_ts(e) && this.midnight_ts(this) <= this.midnight_ts(r);
      case "[]":
        return this.midnight_ts() >= this.midnight_ts(e) && this.midnight_ts() <= this.midnight_ts(r);
    }
  }
  isBefore(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
      case "month":
      case "months":
        return new Date(e.getFullYear(), e.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();
      case "year":
      case "years":
        return e.getFullYear() > this.getFullYear();
    }
    throw new Error("isBefore: Invalid unit!");
  }
  isSameOrBefore(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
      case "month":
      case "months":
        return new Date(e.getFullYear(), e.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
    }
    throw new Error("isSameOrBefore: Invalid unit!");
  }
  isAfter(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(e.getFullYear(), e.getMonth(), 1).getTime();
      case "year":
      case "years":
        return this.getFullYear() > e.getFullYear();
    }
    throw new Error("isAfter: Invalid unit!");
  }
  isSameOrAfter(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(e.getFullYear(), e.getMonth(), 1).getTime();
    }
    throw new Error("isSameOrAfter: Invalid unit!");
  }
  isSame(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(e.getFullYear(), e.getMonth(), e.getDate()).getTime();
      case "month":
      case "months":
        return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(e.getFullYear(), e.getMonth(), 1).getTime();
    }
    throw new Error("isSame: Invalid unit!");
  }
  add(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        this.setDate(this.getDate() + e);
        break;
      case "month":
      case "months":
        this.setMonth(this.getMonth() + e);
    }
    return this;
  }
  subtract(e, r = "days") {
    switch (r) {
      case "day":
      case "days":
        this.setDate(this.getDate() - e);
        break;
      case "month":
      case "months":
        this.setMonth(this.getMonth() - e);
    }
    return this;
  }
  diff(e, r = "days") {
    switch (r) {
      default:
      case "day":
      case "days":
        return Math.round((this.midnight_ts() - this.midnight_ts(e)) / 864e5);
      case "month":
      case "months":
        let a = 12 * (e.getFullYear() - this.getFullYear());
        return a -= e.getMonth(), a += this.getMonth(), a;
    }
  }
  format(e, r = "en-US") {
    let a = "";
    const o = [];
    let c = null;
    for (; (c = S.regex.exec(e)) != null; )
      c[1] !== "\\" && o.push(c);
    if (o.length) {
      o[0].index > 0 && (a += e.substring(0, o[0].index));
      for (const [l, u] of Object.entries(o)) {
        const h = Number(l);
        a += this.formatTokens(u[0], r), o[h + 1] && (a += e.substring(u.index + u[0].length, o[h + 1].index)), h === o.length - 1 && (a += e.substring(u.index + u[0].length));
      }
    }
    return a.replace(/\\/g, "");
  }
  midnight_ts(e) {
    return e ? new Date(e.getFullYear(), e.getMonth(), e.getDate(), 0, 0, 0, 0).getTime() : new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
  }
  formatTokens(e, r) {
    switch (e) {
      case "YY":
        return String(this.getFullYear()).slice(-2);
      case "YYYY":
        return String(this.getFullYear());
      case "M":
        return String(this.getMonth() + 1);
      case "MM":
        return `0${this.getMonth() + 1}`.slice(-2);
      case "MMM":
        return S.shortMonths(r)[this.getMonth()];
      case "MMMM":
        return S.longMonths(r)[this.getMonth()];
      case "D":
        return String(this.getDate());
      case "DD":
        return `0${this.getDate()}`.slice(-2);
      case "H":
        return String(this.getHours());
      case "HH":
        return `0${this.getHours()}`.slice(-2);
      case "h":
        return String(this.getHours() % 12 || 12);
      case "hh":
        return `0${this.getHours() % 12 || 12}`.slice(-2);
      case "m":
        return String(this.getMinutes());
      case "mm":
        return `0${this.getMinutes()}`.slice(-2);
      case "s":
        return String(this.getSeconds());
      case "ss":
        return `0${this.getSeconds()}`.slice(-2);
      case "a":
        return this.getHours() < 12 || this.getHours() === 24 ? "am" : "pm";
      case "A":
        return this.getHours() < 12 || this.getHours() === 24 ? "AM" : "PM";
      default:
        return "";
    }
  }
}, D(S, "regex", /(\\)?(Y{2,4}|M{1,4}|D{1,2}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|A|a)/g), D(S, "MONTH_JS", [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]), S);
class At {
  constructor(n) {
    D(this, "picker");
    this.picker = n;
  }
  render(n, e) {
    n || (n = new w()), n.setDate(1), n.setHours(0, 0, 0, 0), typeof this[`get${e}View`] == "function" && this[`get${e}View`](n);
  }
  getContainerView(n) {
    this.picker.ui.container.innerHTML = "", this.picker.options.header && this.picker.trigger("render", { date: n.clone(), view: "Header" }), this.picker.trigger("render", { date: n.clone(), view: "Main" }), this.picker.options.autoApply || this.picker.trigger("render", { date: n.clone(), view: "Footer" });
  }
  getHeaderView(n) {
    const e = document.createElement("header");
    this.picker.options.header instanceof HTMLElement && e.appendChild(this.picker.options.header), typeof this.picker.options.header == "string" && (e.innerHTML = this.picker.options.header), this.picker.ui.container.appendChild(e), this.picker.trigger("view", { target: e, date: n.clone(), view: "Header" });
  }
  getMainView(n) {
    const e = document.createElement("main");
    this.picker.ui.container.appendChild(e);
    const r = document.createElement("div");
    r.className = `calendars grid-${this.picker.options.grid}`;
    for (let a = 0; a < this.picker.options.calendars; a++) {
      const o = document.createElement("div");
      o.className = "calendar", r.appendChild(o);
      const c = this.getCalendarHeaderView(n.clone());
      o.appendChild(c), this.picker.trigger("view", { date: n.clone(), view: "CalendarHeader", index: a, target: c });
      const l = this.getCalendarDayNamesView();
      o.appendChild(l), this.picker.trigger("view", { date: n.clone(), view: "CalendarDayNames", index: a, target: l });
      const u = this.getCalendarDaysView(n.clone());
      o.appendChild(u), this.picker.trigger("view", { date: n.clone(), view: "CalendarDays", index: a, target: u });
      const h = this.getCalendarFooterView(this.picker.options.lang, n.clone());
      o.appendChild(h), this.picker.trigger("view", { date: n.clone(), view: "CalendarFooter", index: a, target: h }), this.picker.trigger("view", { date: n.clone(), view: "CalendarItem", index: a, target: o }), n.add(1, "month");
    }
    e.appendChild(r), this.picker.trigger("view", { date: n.clone(), view: "Calendars", target: r }), this.picker.trigger("view", { date: n.clone(), view: "Main", target: e });
  }
  getFooterView(n) {
    const e = document.createElement("footer"), r = document.createElement("div");
    r.className = "footer-buttons";
    const a = document.createElement("button");
    a.className = "cancel-button unit", a.innerHTML = this.picker.options.locale.cancel, r.appendChild(a);
    const o = document.createElement("button");
    o.className = "apply-button unit", o.innerHTML = this.picker.options.locale.apply, o.disabled = !0, r.appendChild(o), e.appendChild(r), this.picker.ui.container.appendChild(e), this.picker.trigger("view", { date: n, target: e, view: "Footer" });
  }
  getCalendarHeaderView(n) {
    const e = document.createElement("div");
    e.className = "header";
    const r = document.createElement("div");
    r.className = "month-name", r.innerHTML = `<span>${n.toLocaleString(this.picker.options.lang, { month: "long" })}</span> ${n.format("YYYY")}`, e.appendChild(r);
    const a = document.createElement("button");
    a.className = "previous-button unit", a.innerHTML = this.picker.options.locale.previousMonth, e.appendChild(a);
    const o = document.createElement("button");
    return o.className = "next-button unit", o.innerHTML = this.picker.options.locale.nextMonth, e.appendChild(o), e;
  }
  getCalendarDayNamesView() {
    const n = document.createElement("div");
    n.className = "daynames-row";
    for (let e = 1; e <= 7; e++) {
      const r = 3 + this.picker.options.firstDay + e, a = document.createElement("div");
      a.className = "dayname", a.innerHTML = new Date(1970, 0, r, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, { weekday: "short" }), a.title = new Date(1970, 0, r, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, { weekday: "long" }), n.appendChild(a), this.picker.trigger("view", { dayIdx: r, view: "CalendarDayName", target: a });
    }
    return n;
  }
  getCalendarDaysView(n) {
    const e = document.createElement("div");
    e.className = "days-grid";
    const r = this.calcOffsetDays(n, this.picker.options.firstDay), a = 32 - new Date(n.getFullYear(), n.getMonth(), 32).getDate();
    for (let o = 0; o < r; o++) {
      const c = document.createElement("div");
      c.className = "offset", e.appendChild(c);
    }
    for (let o = 1; o <= a; o++) {
      n.setDate(o);
      const c = this.getCalendarDayView(n);
      e.appendChild(c), this.picker.trigger("view", { date: n, view: "CalendarDay", target: c });
    }
    return e;
  }
  getCalendarDayView(n) {
    const e = this.picker.options.date ? new w(this.picker.options.date) : null, r = new w(), a = document.createElement("div");
    return a.className = "day unit", a.innerHTML = n.format("D"), a.dataset.time = String(n.getTime()), n.isSame(r, "day") && a.classList.add("today"), [0, 6].includes(n.getDay()) && a.classList.add("weekend"), this.picker.datePicked.length ? this.picker.datePicked[0].isSame(n, "day") && a.classList.add("selected") : e && n.isSame(e, "day") && a.classList.add("selected"), this.picker.trigger("view", { date: n, view: "CalendarDay", target: a }), a;
  }
  getCalendarFooterView(n, e) {
    const r = document.createElement("div");
    return r.className = "footer", r;
  }
  calcOffsetDays(n, e) {
    let r = n.getDay() - e;
    return r < 0 && (r += 7), r;
  }
}
let Nt = class {
  constructor(n) {
    D(this, "picker");
    D(this, "instances", {});
    this.picker = n;
  }
  initialize() {
    const n = [];
    this.picker.options.plugins.forEach((e) => {
      typeof e == "function" ? n.push(new e()) : typeof e == "string" && typeof easepick < "u" && Object.prototype.hasOwnProperty.call(easepick, e) ? n.push(new easepick[e]()) : console.warn(`easepick: ${e} not found.`);
    }), n.sort((e, r) => e.priority > r.priority ? -1 : e.priority < r.priority || e.dependencies.length > r.dependencies.length ? 1 : e.dependencies.length < r.dependencies.length ? -1 : 0), n.forEach((e) => {
      e.attach(this.picker), this.instances[e.getName()] = e;
    });
  }
  getInstance(n) {
    return this.instances[n];
  }
  addInstance(n) {
    if (Object.prototype.hasOwnProperty.call(this.instances, n))
      console.warn(`easepick: ${n} already added.`);
    else {
      if (typeof easepick < "u" && Object.prototype.hasOwnProperty.call(easepick, n)) {
        const e = new easepick[n]();
        return e.attach(this.picker), this.instances[e.getName()] = e, e;
      }
      if (this.getPluginFn(n) !== "undefined") {
        const e = new (this.getPluginFn(n))();
        return e.attach(this.picker), this.instances[e.getName()] = e, e;
      }
      console.warn(`easepick: ${n} not found.`);
    }
    return null;
  }
  removeInstance(n) {
    return n in this.instances && this.instances[n].detach(), delete this.instances[n];
  }
  reloadInstance(n) {
    return this.removeInstance(n), this.addInstance(n);
  }
  getPluginFn(n) {
    return [...this.picker.options.plugins].filter((e) => typeof e == "function" && new e().getName() === n).shift();
  }
};
class Ye {
  constructor(n) {
    D(this, "Calendar", new At(this));
    D(this, "PluginManager", new Nt(this));
    D(this, "calendars", []);
    D(this, "datePicked", []);
    D(this, "cssLoaded", 0);
    D(this, "binds", { hidePicker: this.hidePicker.bind(this), show: this.show.bind(this) });
    D(this, "options", { doc: document, css: [], element: null, firstDay: 1, grid: 1, calendars: 1, lang: "en-US", date: null, format: "YYYY-MM-DD", readonly: !0, autoApply: !0, header: !1, inline: !1, scrollToDate: !0, locale: { nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>', previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>', cancel: "Cancel", apply: "Apply" }, documentClick: this.binds.hidePicker, plugins: [] });
    D(this, "ui", { container: null, shadowRoot: null, wrapper: null });
    D(this, "version", "1.2.1");
    const e = { ...this.options.locale, ...n.locale };
    this.options = { ...this.options, ...n }, this.options.locale = e, this.handleOptions(), this.ui.wrapper = document.createElement("span"), this.ui.wrapper.style.display = "none", this.ui.wrapper.style.position = "absolute", this.ui.wrapper.style.pointerEvents = "none", this.ui.wrapper.className = "easepick-wrapper", this.ui.wrapper.attachShadow({ mode: "open" }), this.ui.shadowRoot = this.ui.wrapper.shadowRoot, this.ui.container = document.createElement("div"), this.ui.container.className = "container", this.options.zIndex && (this.ui.container.style.zIndex = String(this.options.zIndex)), this.options.inline && (this.ui.wrapper.style.position = "relative", this.ui.container.classList.add("inline")), this.ui.shadowRoot.appendChild(this.ui.container), this.options.element.after(this.ui.wrapper), this.handleCSS(), this.options.element.addEventListener("click", this.binds.show), this.on("view", this.onView.bind(this)), this.on("render", this.onRender.bind(this)), this.PluginManager.initialize(), this.parseValues(), typeof this.options.setup == "function" && this.options.setup(this), this.on("click", this.onClick.bind(this));
    const r = this.options.scrollToDate ? this.getDate() : null;
    this.renderAll(r);
  }
  on(n, e, r = {}) {
    this.ui.container.addEventListener(n, e, r);
  }
  off(n, e, r = {}) {
    this.ui.container.removeEventListener(n, e, r);
  }
  trigger(n, e = {}) {
    return this.ui.container.dispatchEvent(new CustomEvent(n, { detail: e }));
  }
  destroy() {
    this.options.element.removeEventListener("click", this.binds.show), typeof this.options.documentClick == "function" && document.removeEventListener("click", this.options.documentClick, !0), Object.keys(this.PluginManager.instances).forEach((n) => {
      this.PluginManager.removeInstance(n);
    }), this.ui.wrapper.remove();
  }
  onRender(n) {
    const { view: e, date: r } = n.detail;
    this.Calendar.render(r, e);
  }
  onView(n) {
    const { view: e, target: r } = n.detail;
    e === "Footer" && this.datePicked.length && (r.querySelector(".apply-button").disabled = !1);
  }
  onClickHeaderButton(n) {
    this.isCalendarHeaderButton(n) && (n.classList.contains("next-button") ? this.calendars[0].add(1, "month") : this.calendars[0].subtract(1, "month"), this.renderAll(this.calendars[0]));
  }
  onClickCalendarDay(n) {
    if (this.isCalendarDay(n)) {
      const e = new w(n.dataset.time);
      this.options.autoApply ? (this.setDate(e), this.trigger("select", { date: this.getDate() }), this.hide()) : (this.datePicked[0] = e, this.trigger("preselect", { date: this.getDate() }), this.renderAll());
    }
  }
  onClickApplyButton(n) {
    if (this.isApplyButton(n)) {
      if (this.datePicked[0] instanceof Date) {
        const e = this.datePicked[0].clone();
        this.setDate(e);
      }
      this.hide(), this.trigger("select", { date: this.getDate() });
    }
  }
  onClickCancelButton(n) {
    this.isCancelButton(n) && this.hide();
  }
  onClick(n) {
    const e = n.target;
    if (e instanceof HTMLElement) {
      const r = e.closest(".unit");
      if (!(r instanceof HTMLElement))
        return;
      this.onClickHeaderButton(r), this.onClickCalendarDay(r), this.onClickApplyButton(r), this.onClickCancelButton(r);
    }
  }
  isShown() {
    return this.ui.container.classList.contains("inline") || this.ui.container.classList.contains("show");
  }
  show(n) {
    if (this.isShown())
      return;
    const e = n && "target" in n ? n.target : this.options.element, { top: r, left: a } = this.adjustPosition(e);
    this.ui.container.style.top = `${r}px`, this.ui.container.style.left = `${a}px`, this.ui.container.classList.add("show"), this.trigger("show", { target: e });
  }
  hide() {
    this.ui.container.classList.remove("show"), this.datePicked.length = 0, this.renderAll(), this.trigger("hide");
  }
  setDate(n) {
    const e = new w(n, this.options.format);
    this.options.date = e.clone(), this.updateValues(), this.calendars.length && this.renderAll();
  }
  getDate() {
    return this.options.date instanceof w ? this.options.date.clone() : null;
  }
  parseValues() {
    this.options.date ? this.setDate(this.options.date) : this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.setDate(this.options.element.value), this.options.date instanceof Date || (this.options.date = null);
  }
  updateValues() {
    const n = this.getDate(), e = n instanceof Date ? n.format(this.options.format, this.options.lang) : "", r = this.options.element;
    r instanceof HTMLInputElement ? r.value = e : r instanceof HTMLElement && (r.innerText = e);
  }
  hidePicker(n) {
    let e = n.target, r = null;
    e.shadowRoot && (e = n.composedPath()[0], r = e.getRootNode().host), this.isShown() && r !== this.ui.wrapper && e !== this.options.element && this.hide();
  }
  renderAll(n) {
    this.trigger("render", { view: "Container", date: (n || this.calendars[0]).clone() });
  }
  isCalendarHeaderButton(n) {
    return ["previous-button", "next-button"].some((e) => n.classList.contains(e));
  }
  isCalendarDay(n) {
    return n.classList.contains("day");
  }
  isApplyButton(n) {
    return n.classList.contains("apply-button");
  }
  isCancelButton(n) {
    return n.classList.contains("cancel-button");
  }
  gotoDate(n) {
    const e = new w(n, this.options.format);
    e.setDate(1), this.calendars[0] = e.clone(), this.renderAll();
  }
  clear() {
    this.options.date = null, this.datePicked.length = 0, this.updateValues(), this.renderAll(), this.trigger("clear");
  }
  handleOptions() {
    this.options.element instanceof HTMLElement || (this.options.element = this.options.doc.querySelector(this.options.element)), typeof this.options.documentClick == "function" && document.addEventListener("click", this.options.documentClick, !0), this.options.element instanceof HTMLInputElement && (this.options.element.readOnly = this.options.readonly), this.options.date ? this.calendars[0] = new w(this.options.date, this.options.format) : this.calendars[0] = new w();
  }
  handleCSS() {
    if (Array.isArray(this.options.css))
      this.options.css.forEach((n) => {
        const e = document.createElement("link");
        e.href = n, e.rel = "stylesheet";
        const r = () => {
          this.cssLoaded++, this.cssLoaded === this.options.css.length && (this.ui.wrapper.style.display = "");
        };
        e.addEventListener("load", r), e.addEventListener("error", r), this.ui.shadowRoot.append(e);
      });
    else if (typeof this.options.css == "string") {
      const n = document.createElement("style"), e = document.createTextNode(this.options.css);
      n.appendChild(e), this.ui.shadowRoot.append(n), this.ui.wrapper.style.display = "";
    } else
      typeof this.options.css == "function" && (this.options.css.call(this, this), this.ui.wrapper.style.display = "");
  }
  adjustPosition(n) {
    const e = n.getBoundingClientRect(), r = this.ui.wrapper.getBoundingClientRect();
    this.ui.container.classList.add("calc");
    const a = this.ui.container.getBoundingClientRect();
    this.ui.container.classList.remove("calc");
    let o = e.bottom - r.bottom, c = e.left - r.left;
    return typeof window < "u" && (window.innerHeight < o + a.height && o - a.height >= 0 && (o = e.top - r.top - a.height), window.innerWidth < c + a.width && e.right - a.width >= 0 && (c = e.right - r.right - a.width)), { left: c, top: o };
  }
}
var ze = Object.freeze({ __proto__: null, Core: Ye, create: Ye });
class We {
  constructor() {
    D(this, "picker");
    D(this, "options");
    D(this, "priority", 0);
    D(this, "dependencies", []);
  }
  attach(n) {
    const e = this.getName(), r = { ...this.options };
    this.options = { ...this.options, ...n.options[e] || {} };
    for (const o of Object.keys(r))
      if (r[o] !== null && typeof r[o] == "object" && Object.keys(r[o]).length && e in n.options && o in n.options[e]) {
        const c = { ...n.options[e][o] };
        c !== null && typeof c == "object" && Object.keys(c).length && Object.keys(c).every((l) => Object.keys(r[o]).includes(l)) && (this.options[o] = { ...r[o], ...c });
      }
    if (this.picker = n, this.dependenciesNotFound()) {
      const o = this.dependencies.filter((c) => !this.pluginsAsStringArray().includes(c));
      return void console.warn(`${this.getName()}: required dependencies (${o.join(", ")}).`);
    }
    const a = this.camelCaseToKebab(this.getName());
    this.picker.ui.container.classList.add(a), this.onAttach();
  }
  detach() {
    const n = this.camelCaseToKebab(this.getName());
    this.picker.ui.container.classList.remove(n), typeof this.onDetach == "function" && this.onDetach();
  }
  dependenciesNotFound() {
    return this.dependencies.length && !this.dependencies.every((n) => this.pluginsAsStringArray().includes(n));
  }
  pluginsAsStringArray() {
    return this.picker.options.plugins.map((n) => typeof n == "function" ? new n().getName() : n);
  }
  camelCaseToKebab(n) {
    return n.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
  }
}
class Ue extends We {
  constructor() {
    super(...arguments);
    D(this, "priority", 1);
    D(this, "binds", { onView: this.onView.bind(this) });
    D(this, "options", { minDate: null, maxDate: null, minDays: null, maxDays: null, selectForward: null, selectBackward: null, presets: !0, inseparable: !1, filter: null });
  }
  getName() {
    return "LockPlugin";
  }
  onAttach() {
    if (this.options.minDate && (this.options.minDate = new w(this.options.minDate, this.picker.options.format, this.picker.options.lang)), this.options.maxDate && (this.options.maxDate = new w(this.options.maxDate, this.picker.options.format, this.picker.options.lang), this.options.maxDate instanceof w && this.picker.options.calendars > 1 && this.picker.calendars[0].isSame(this.options.maxDate, "month"))) {
      const e = this.picker.calendars[0].clone().subtract(1, "month");
      this.picker.gotoDate(e);
    }
    if ((this.options.minDays || this.options.maxDays || this.options.selectForward || this.options.selectBackward) && !this.picker.options.plugins.includes("RangePlugin")) {
      const e = ["minDays", "maxDays", "selectForward", "selectBackward"];
      console.warn(`${this.getName()}: options ${e.join(", ")} required RangePlugin.`);
    }
    this.picker.on("view", this.binds.onView);
  }
  onDetach() {
    this.picker.off("view", this.binds.onView);
  }
  onView(e) {
    const { view: r, target: a, date: o } = e.detail;
    if (r === "CalendarHeader" && (this.options.minDate instanceof w && o.isSameOrBefore(this.options.minDate, "month") && a.classList.add("no-previous-month"), this.options.maxDate instanceof w && o.isSameOrAfter(this.options.maxDate, "month") && a.classList.add("no-next-month")), r === "CalendarDay") {
      const c = this.picker.datePicked.length ? this.picker.datePicked[0] : null;
      if (this.testFilter(o))
        return void a.classList.add("locked");
      if (this.options.inseparable) {
        if (this.options.minDays) {
          const l = o.clone().subtract(this.options.minDays - 1, "day"), u = o.clone().add(this.options.minDays - 1, "day");
          let h = !1, p = !1;
          for (; l.isBefore(o, "day"); ) {
            if (this.testFilter(l)) {
              h = !0;
              break;
            }
            l.add(1, "day");
          }
          for (; u.isAfter(o, "day"); ) {
            if (this.testFilter(u)) {
              p = !0;
              break;
            }
            u.subtract(1, "day");
          }
          h && p && a.classList.add("not-available");
        }
        this.rangeIsNotAvailable(o, c) && a.classList.add("not-available");
      }
      this.dateIsNotAvailable(o, c) && a.classList.add("not-available");
    }
    if (this.options.presets && r === "PresetPluginButton") {
      const c = new w(Number(a.dataset.start)), l = new w(Number(a.dataset.end)), u = l.diff(c, "day"), h = this.options.minDays && u < this.options.minDays, p = this.options.maxDays && u > this.options.maxDays;
      (h || p || this.lockMinDate(c) || this.lockMaxDate(c) || this.lockMinDate(l) || this.lockMaxDate(l) || this.rangeIsNotAvailable(c, l)) && a.setAttribute("disabled", "disabled");
    }
  }
  dateIsNotAvailable(e, r) {
    return this.lockMinDate(e) || this.lockMaxDate(e) || this.lockMinDays(e, r) || this.lockMaxDays(e, r) || this.lockSelectForward(e) || this.lockSelectBackward(e);
  }
  rangeIsNotAvailable(e, r) {
    if (!e || !r)
      return !1;
    const a = (e.isSameOrBefore(r, "day") ? e : r).clone(), o = (r.isSameOrAfter(e, "day") ? r : e).clone();
    for (; a.isSameOrBefore(o, "day"); ) {
      if (this.testFilter(a))
        return !0;
      a.add(1, "day");
    }
    return !1;
  }
  lockMinDate(e) {
    return this.options.minDate instanceof w && e.isBefore(this.options.minDate, "day");
  }
  lockMaxDate(e) {
    return this.options.maxDate instanceof w && e.isAfter(this.options.maxDate, "day");
  }
  lockMinDays(e, r) {
    if (this.options.minDays && r) {
      const a = r.clone().subtract(this.options.minDays - 1, "day"), o = r.clone().add(this.options.minDays - 1, "day");
      return e.isBetween(a, o);
    }
    return !1;
  }
  lockMaxDays(e, r) {
    if (this.options.maxDays && r) {
      const a = r.clone().subtract(this.options.maxDays, "day"), o = r.clone().add(this.options.maxDays, "day");
      return !e.isBetween(a, o);
    }
    return !1;
  }
  lockSelectForward(e) {
    if (this.picker.datePicked.length === 1 && this.options.selectForward) {
      const r = this.picker.datePicked[0].clone();
      return e.isBefore(r, "day");
    }
    return !1;
  }
  lockSelectBackward(e) {
    if (this.picker.datePicked.length === 1 && this.options.selectBackward) {
      const r = this.picker.datePicked[0].clone();
      return e.isAfter(r, "day");
    }
    return !1;
  }
  testFilter(e) {
    return typeof this.options.filter == "function" && this.options.filter(e, this.picker.datePicked);
  }
}
class Ot extends We {
  constructor() {
    super(...arguments);
    D(this, "tooltipElement");
    D(this, "triggerElement");
    D(this, "binds", { setStartDate: this.setStartDate.bind(this), setEndDate: this.setEndDate.bind(this), setDateRange: this.setDateRange.bind(this), getStartDate: this.getStartDate.bind(this), getEndDate: this.getEndDate.bind(this), onView: this.onView.bind(this), onShow: this.onShow.bind(this), onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onClickCalendarDay: this.onClickCalendarDay.bind(this), onClickApplyButton: this.onClickApplyButton.bind(this), parseValues: this.parseValues.bind(this), updateValues: this.updateValues.bind(this), clear: this.clear.bind(this) });
    D(this, "options", { elementEnd: null, startDate: null, endDate: null, repick: !1, strict: !0, delimiter: " - ", tooltip: !0, tooltipNumber: (e) => e, locale: { zero: "", one: "day", two: "", few: "", many: "", other: "days" }, documentClick: this.hidePicker.bind(this) });
  }
  getName() {
    return "RangePlugin";
  }
  onAttach() {
    this.binds._setStartDate = this.picker.setStartDate, this.binds._setEndDate = this.picker.setEndDate, this.binds._setDateRange = this.picker.setDateRange, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, this.binds._parseValues = this.picker.parseValues, this.binds._updateValues = this.picker.updateValues, this.binds._clear = this.picker.clear, this.binds._onClickCalendarDay = this.picker.onClickCalendarDay, this.binds._onClickApplyButton = this.picker.onClickApplyButton, Object.defineProperties(this.picker, { setStartDate: { configurable: !0, value: this.binds.setStartDate }, setEndDate: { configurable: !0, value: this.binds.setEndDate }, setDateRange: { configurable: !0, value: this.binds.setDateRange }, getStartDate: { configurable: !0, value: this.binds.getStartDate }, getEndDate: { configurable: !0, value: this.binds.getEndDate }, parseValues: { configurable: !0, value: this.binds.parseValues }, updateValues: { configurable: !0, value: this.binds.updateValues }, clear: { configurable: !0, value: this.binds.clear }, onClickCalendarDay: { configurable: !0, value: this.binds.onClickCalendarDay }, onClickApplyButton: { configurable: !0, value: this.binds.onClickApplyButton } }), this.options.elementEnd && (this.options.elementEnd instanceof HTMLElement || (this.options.elementEnd = this.picker.options.doc.querySelector(this.options.elementEnd)), this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.readOnly = this.picker.options.readonly), typeof this.picker.options.documentClick == "function" && (document.removeEventListener("click", this.picker.options.documentClick, !0), typeof this.options.documentClick == "function" && document.addEventListener("click", this.options.documentClick, !0)), this.options.elementEnd.addEventListener("click", this.picker.show.bind(this.picker))), this.options.repick = this.options.repick && this.options.elementEnd instanceof HTMLElement, this.picker.options.date = null, this.picker.on("view", this.binds.onView), this.picker.on("show", this.binds.onShow), this.picker.on("mouseenter", this.binds.onMouseEnter, !0), this.picker.on("mouseleave", this.binds.onMouseLeave, !0), this.checkIntlPluralLocales();
  }
  onDetach() {
    Object.defineProperties(this.picker, { setStartDate: { configurable: !0, value: this.binds._setStartDate }, setEndDate: { configurable: !0, value: this.binds._setEndDate }, setDateRange: { configurable: !0, value: this.binds._setDateRange }, getStartDate: { configurable: !0, value: this.binds._getStartDate }, getEndDate: { configurable: !0, value: this.binds._getEndDate }, parseValues: { configurable: !0, value: this.binds._parseValues }, updateValues: { configurable: !0, value: this.binds._updateValues }, clear: { configurable: !0, value: this.binds._clear }, onClickCalendarDay: { configurable: !0, value: this.binds._onClickCalendarDay }, onClickApplyButton: { configurable: !0, value: this.binds._onClickApplyButton } }), this.picker.off("view", this.binds.onView), this.picker.off("show", this.binds.onShow), this.picker.off("mouseenter", this.binds.onMouseEnter, !0), this.picker.off("mouseleave", this.binds.onMouseLeave, !0);
  }
  parseValues() {
    if (this.options.startDate || this.options.endDate)
      this.options.strict ? this.options.startDate && this.options.endDate ? this.setDateRange(this.options.startDate, this.options.endDate) : (this.options.startDate = null, this.options.endDate = null) : (this.options.startDate && this.setStartDate(this.options.startDate), this.options.endDate && this.setEndDate(this.options.endDate));
    else if (this.options.elementEnd)
      this.options.strict ? this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setDateRange(this.picker.options.element.value, this.options.elementEnd.value) : (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.setStartDate(this.picker.options.element.value), this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setEndDate(this.options.elementEnd.value));
    else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
      const [e, r] = this.picker.options.element.value.split(this.options.delimiter);
      this.options.strict ? e && r && this.setDateRange(e, r) : (e && this.setStartDate(e), r && this.setEndDate(r));
    }
  }
  updateValues() {
    const e = this.picker.options.element, r = this.options.elementEnd, a = this.picker.getStartDate(), o = this.picker.getEndDate(), c = a instanceof Date ? a.format(this.picker.options.format, this.picker.options.lang) : "", l = o instanceof Date ? o.format(this.picker.options.format, this.picker.options.lang) : "";
    if (r)
      e instanceof HTMLInputElement ? e.value = c : e instanceof HTMLElement && (e.innerText = c), r instanceof HTMLInputElement ? r.value = l : r instanceof HTMLElement && (r.innerText = l);
    else {
      const u = `${c}${c || l ? this.options.delimiter : ""}${l}`;
      e instanceof HTMLInputElement ? e.value = u : e instanceof HTMLElement && (e.innerText = u);
    }
  }
  clear() {
    this.options.startDate = null, this.options.endDate = null, this.picker.datePicked.length = 0, this.updateValues(), this.picker.renderAll(), this.picker.trigger("clear");
  }
  onShow(e) {
    const { target: r } = e.detail;
    this.triggerElement = r, this.picker.options.scrollToDate && this.getStartDate() instanceof Date && this.picker.gotoDate(this.getStartDate()), this.initializeRepick();
  }
  onView(e) {
    const { view: r, target: a } = e.detail;
    if (r === "Main" && (this.tooltipElement = document.createElement("span"), this.tooltipElement.className = "range-plugin-tooltip", a.appendChild(this.tooltipElement)), r === "CalendarDay") {
      const o = new w(a.dataset.time), c = this.picker.datePicked, l = c.length ? this.picker.datePicked[0] : this.getStartDate(), u = c.length ? this.picker.datePicked[1] : this.getEndDate();
      l && l.isSame(o, "day") && a.classList.add("start"), l && u && (u.isSame(o, "day") && a.classList.add("end"), o.isBetween(l, u) && a.classList.add("in-range"));
    }
    if (r === "Footer") {
      const o = this.picker.datePicked.length === 1 && !this.options.strict || this.picker.datePicked.length === 2;
      a.querySelector(".apply-button").disabled = !o;
    }
  }
  hidePicker(e) {
    let r = e.target, a = null;
    r.shadowRoot && (r = e.composedPath()[0], a = r.getRootNode().host), this.picker.isShown() && a !== this.picker.ui.wrapper && r !== this.picker.options.element && r !== this.options.elementEnd && this.picker.hide();
  }
  setStartDate(e) {
    const r = new w(e, this.picker.options.format);
    this.options.startDate = r ? r.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  setEndDate(e) {
    const r = new w(e, this.picker.options.format);
    this.options.endDate = r ? r.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  setDateRange(e, r) {
    const a = new w(e, this.picker.options.format), o = new w(r, this.picker.options.format);
    this.options.startDate = a ? a.clone() : null, this.options.endDate = o ? o.clone() : null, this.updateValues(), this.picker.renderAll();
  }
  getStartDate() {
    return this.options.startDate instanceof Date ? this.options.startDate.clone() : null;
  }
  getEndDate() {
    return this.options.endDate instanceof Date ? this.options.endDate.clone() : null;
  }
  onMouseEnter(e) {
    const r = e.target;
    if (r instanceof HTMLElement) {
      this.isContainer(r) && this.initializeRepick();
      const a = r.closest(".unit");
      if (!(a instanceof HTMLElement))
        return;
      if (this.picker.isCalendarDay(a)) {
        if (this.picker.datePicked.length !== 1)
          return;
        let o = this.picker.datePicked[0].clone(), c = new w(a.dataset.time), l = !1;
        if (o.isAfter(c, "day")) {
          const u = o.clone();
          o = c.clone(), c = u.clone(), l = !0;
        }
        if ([...this.picker.ui.container.querySelectorAll(".day")].forEach((u) => {
          const h = new w(u.dataset.time), p = this.picker.Calendar.getCalendarDayView(h);
          h.isBetween(o, c) && p.classList.add("in-range"), h.isSame(this.picker.datePicked[0], "day") && (p.classList.add("start"), p.classList.toggle("flipped", l)), u === a && (p.classList.add("end"), p.classList.toggle("flipped", l)), u.className = p.className;
        }), this.options.tooltip) {
          const u = this.options.tooltipNumber(c.diff(o, "day") + 1);
          if (u > 0) {
            const h = new Intl.PluralRules(this.picker.options.lang).select(u), p = `${u} ${this.options.locale[h]}`;
            this.showTooltip(a, p);
          } else
            this.hideTooltip();
        }
      }
    }
  }
  onMouseLeave(e) {
    if (this.isContainer(e.target) && this.options.repick) {
      const r = this.getStartDate(), a = this.getEndDate();
      r && a && (this.picker.datePicked.length = 0, this.picker.renderAll());
    }
  }
  onClickCalendarDay(e) {
    if (this.picker.isCalendarDay(e)) {
      this.picker.datePicked.length === 2 && (this.picker.datePicked.length = 0);
      const r = new w(e.dataset.time);
      if (this.picker.datePicked[this.picker.datePicked.length] = r, this.picker.datePicked.length === 2 && this.picker.datePicked[0].isAfter(this.picker.datePicked[1])) {
        const a = this.picker.datePicked[1].clone();
        this.picker.datePicked[1] = this.picker.datePicked[0].clone(), this.picker.datePicked[0] = a.clone();
      }
      this.picker.datePicked.length !== 1 && this.picker.options.autoApply || this.picker.trigger("preselect", { start: this.picker.datePicked[0] instanceof Date ? this.picker.datePicked[0].clone() : null, end: this.picker.datePicked[1] instanceof Date ? this.picker.datePicked[1].clone() : null }), this.picker.datePicked.length === 1 && (!this.options.strict && this.picker.options.autoApply && (this.picker.options.element === this.triggerElement && this.setStartDate(this.picker.datePicked[0]), this.options.elementEnd === this.triggerElement && this.setEndDate(this.picker.datePicked[0]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() })), this.picker.renderAll()), this.picker.datePicked.length === 2 && (this.picker.options.autoApply ? (this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() }), this.picker.hide()) : (this.hideTooltip(), this.picker.renderAll()));
    }
  }
  onClickApplyButton(e) {
    this.picker.isApplyButton(e) && (this.picker.datePicked.length !== 1 || this.options.strict || (this.picker.options.element === this.triggerElement && (this.options.endDate = null, this.setStartDate(this.picker.datePicked[0])), this.options.elementEnd === this.triggerElement && (this.options.startDate = null, this.setEndDate(this.picker.datePicked[0]))), this.picker.datePicked.length === 2 && this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", { start: this.picker.getStartDate(), end: this.picker.getEndDate() }), this.picker.hide());
  }
  showTooltip(e, r) {
    this.tooltipElement.style.visibility = "visible", this.tooltipElement.innerHTML = r;
    const a = this.picker.ui.container.getBoundingClientRect(), o = this.tooltipElement.getBoundingClientRect(), c = e.getBoundingClientRect();
    let l = c.top, u = c.left;
    l -= a.top, u -= a.left, l -= o.height, u -= o.width / 2, u += c.width / 2, this.tooltipElement.style.top = `${l}px`, this.tooltipElement.style.left = `${u}px`;
  }
  hideTooltip() {
    this.tooltipElement.style.visibility = "hidden";
  }
  checkIntlPluralLocales() {
    if (!this.options.tooltip)
      return;
    const e = [.../* @__PURE__ */ new Set([new Intl.PluralRules(this.picker.options.lang).select(0), new Intl.PluralRules(this.picker.options.lang).select(1), new Intl.PluralRules(this.picker.options.lang).select(2), new Intl.PluralRules(this.picker.options.lang).select(6), new Intl.PluralRules(this.picker.options.lang).select(18)])], r = Object.keys(this.options.locale);
    e.every((a) => r.includes(a)) || console.warn(`${this.getName()}: provide locales (${e.join(", ")}) for correct tooltip text.`);
  }
  initializeRepick() {
    if (!this.options.repick)
      return;
    const e = this.getStartDate(), r = this.getEndDate();
    r && this.triggerElement === this.picker.options.element && (this.picker.datePicked[0] = r), e && this.triggerElement === this.options.elementEnd && (this.picker.datePicked[0] = e);
  }
  isContainer(e) {
    return e === this.picker.ui.container;
  }
}
function jt(i) {
  const n = T.useRef(null), [e] = T.useState(() => Math.ceil(Math.random() * 1e3)), r = T.useCallback(function(l) {
    if (!l.target)
      return;
    const u = l.target;
    if (u.classList.contains("day") && !u.classList.contains("locked") && !u.classList.contains("not-available")) {
      const h = u.getAttribute("data-time"), p = new Date(Number(h));
      i({
        start: p,
        end: p
      }), n.current && (n.current.setStartDate(p), n.current.setEndDate(p));
    }
  }, []), a = T.useCallback(function(l) {
    const {
      detail: { start: u, end: h }
    } = l;
    i({
      start: u,
      end: h
    });
  }, []), o = T.useCallback(function(l) {
    if (!n.current)
      return;
    const u = n.current.getStartDate(), h = n.current.getEndDate();
    if (u && h && h.isSame(u) && l.currentTarget) {
      const f = l.currentTarget.querySelector(
        `[data-time="${u.getTime()}"]`
      );
      f == null || f.classList.add("single-day");
    }
  }, []);
  return {
    onClick: r,
    onRender: o,
    onSelect: a,
    picker: n,
    startId: `start_${e}`,
    endId: `end_${e}`
  };
}
function Ft(i, n) {
  return {
    formattedPeriod: T.useMemo(() => {
      if (!n)
        return "";
      const { start: r, end: a } = n, o = Intl.DateTimeFormat(i, {
        day: "numeric",
        month: "short"
      }), c = o.format(r);
      return Tt(r, a) ? c : `${c} - ${o.format(a)}`;
    }, [i, n])
  };
}
const qe = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars .calendar:nth-child(n+2){display:block}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar{padding:8px}.calendar>.header{padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{padding:0;border:none;border-radius:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1)}.calendar>.header .previous-button,.calendar>.header .next-button{display:none}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row{display:none}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}@media (min-width: 992px){.calendars{padding:40px 16px 24px;grid-template-columns:repeat(2,1fr)}.calendars .calendar>.daynames-row{display:grid}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button{display:flex;position:absolute;top:5px}.calendars .calendar:first-child>.header:not(.no-previous-month) .previous-button>svg,.calendars .calendar:nth-child(2)>.header:not(.no-next-month) .next-button>svg{height:24px;width:auto}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:first-child>.header .previous-button{left:0}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar:nth-child(2)>.header .next-button{right:0}.calendars .calendar{padding:8px 24px}.calendars .calendar:nth-child(n+3){display:none}}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}.calendar>.days-grid>.day.absence{background-color:var(--blue-700, #046dd7);color:var(--white, #fff)}.calendar>.days-grid>.day.sold{pointer-events:none;background-color:var(--yellow-600, #dc6803);color:var(--white, #fff)}', Yt = ':host{--color-bg-default: #fff;--color-bg-secondary: #f9f9f9;--color-fg-default: #333;--color-fg-primary: #6b82ff;--color-fg-secondary: #748194;--color-fg-selected: #fff;--color-fg-muted: #9e9e9e;--color-fg-accent: #e63757;--color-btn-primary-bg: #fff;--color-btn-primary-fg: #6b82ff;--color-btn-primary-border: #6b82ff;--color-btn-primary-hover-bg: #6b82ff;--color-btn-primary-hover-fg: #fff;--color-btn-primary-hover-border: #6b82ff;--color-btn-primary-disabled-bg: #a2b0ff;--color-btn-primary-disabled-fg: #fff;--color-btn-primary-disabled-border: #a2b0ff;--color-btn-secondary-bg: #fff;--color-btn-secondary-fg: #748194;--color-btn-secondary-border: #748194;--color-btn-secondary-hover-bg: #748194;--color-btn-secondary-hover-fg: #fff;--color-btn-secondary-hover-border: #748194;--color-btn-secondary-disabled-bg: #b5bbc4;--color-btn-secondary-disabled-fg: #fff;--color-btn-secondary-disabled-border: #b5bbc4;--color-border-default: #ddd;--color-border-locked: #f9f9f9;--day-width: 42px;--day-height: 37px;--border-radius: 2px;--primary-color: #6b82ff;--secondary-color: #748194;--white-color: #fff;--black-color: #333;--lightgray-color: #f9f9f9;--gray-color: #9e9e9e;--red-color: #e63757}*{box-sizing:border-box}.container{display:inline-block;border-radius:4px;overflow:hidden;transform:scale(0);transform-origin:top left;transition:transform .3s ease-out;height:0;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:.8em;cursor:default;color:var(--color-fg-default);pointer-events:all;position:absolute}.container.calc{transition:none;height:auto;visibility:hidden;transform:none}.container.show{transform:scale(1);box-shadow:0 0 25px #0000004d;height:auto}.container.inline{position:relative;top:0;left:0;box-shadow:0 7px 14px #4145581a,0 3px 6px #00000012;height:auto;transform:scaleY(1)}.container>main{background-color:var(--color-bg-default)}.container>header,.container>footer{padding:10px;background-color:var(--color-bg-secondary)}.container>footer .footer-buttons{display:flex;justify-content:flex-end;column-gap:5px}.container>footer .footer-buttons>button{border:1px solid transparent;background-color:transparent;border-radius:var(--border-radius);padding:5px 10px;cursor:pointer}.container>footer .footer-buttons>button.apply-button{color:var(--color-btn-primary-fg);border-color:var(--color-btn-primary-border);background-color:var(--color-btn-primary-bg)}.container>footer .footer-buttons>button.apply-button:hover{color:var(--color-btn-primary-hover-fg);border-color:var(--color-btn-primary-hover-border);background-color:var(--color-btn-primary-hover-bg)}.container>footer .footer-buttons>button.apply-button:disabled{cursor:default;background-color:var(--color-btn-primary-disabled-bg);color:var(--color-btn-primary-disabled-fg);border-color:var(--color-btn-primary-disabled-border)}.container>footer .footer-buttons>button.cancel-button{color:var(--color-btn-secondary-fg);border-color:var(--color-btn-secondary-border);background-color:var(--color-btn-secondary-bg)}.container>footer .footer-buttons>button.cancel-button:hover{color:var(--color-btn-secondary-hover-fg);border-color:var(--color-btn-secondary-hover-border);background-color:var(--color-btn-secondary-hover-bg)}.container>footer .footer-buttons>button.cancel-button:disabled{cursor:default;background-color:var(--color-btn-secondary-disabled-bg);color:var(--color-btn-secondary-disabled-fg);border-color:var(--color-btn-secondary-disabled-border)}.grid-1{grid-template-columns:repeat(1,1fr)}.grid-2{grid-template-columns:repeat(2,1fr)}.grid-3{grid-template-columns:repeat(3,1fr)}.grid-4{grid-template-columns:repeat(4,1fr)}.grid-5{grid-template-columns:repeat(5,1fr)}.grid-6{grid-template-columns:repeat(6,1fr)}.grid-7{grid-template-columns:repeat(7,1fr)}.grid-8{grid-template-columns:repeat(8,1fr)}.grid-9{grid-template-columns:repeat(9,1fr)}.grid-10{grid-template-columns:repeat(10,1fr)}.grid-11{grid-template-columns:repeat(11,1fr)}.grid-12{grid-template-columns:repeat(12,1fr)}.calendars{display:grid}.calendars:not(.grid-1) .calendar>.header .month-name{order:2;text-align:center}.calendars:not(.grid-1) .calendar>.header .previous-button{order:1;visibility:hidden}.calendars:not(.grid-1) .calendar>.header .next-button{order:3;visibility:hidden}.calendars:not(.grid-1) .calendar:first-child>.header .previous-button{visibility:visible}.calendars:not(.grid-1) .calendar:last-child>.header .next-button{visibility:visible}.calendar{padding:10px}.calendar>.header{display:flex;align-items:center;justify-content:space-between;padding:10px;column-gap:5px}.calendar>.header .month-name{flex:1;font-weight:500;font-size:15px}.calendar>.header button{display:flex;align-items:center;justify-content:center;border:1px solid transparent;background-color:transparent;color:var(--color-btn-secondary-fg);padding:4px 7px;border-radius:2px;cursor:pointer}.calendar>.header button:hover{background-color:var(--color-bg-secondary)}.calendar>.header button:hover>svg,.calendar>.header button:hover>img{color:var(--color-fg-primary);fill:var(--color-fg-primary)}.calendar>.header button>svg,.calendar>.header button>img{pointer-events:none;color:var(--color-btn-secondary-fg);fill:var(--color-btn-secondary-fg);transform:scale(.7)}.calendar>.days-grid,.calendar>.daynames-row{display:grid;grid-template-columns:repeat(7,1fr);row-gap:2px}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{cursor:default;display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:13px}.calendar>.daynames-row>.dayname{padding:5px 0;color:var(--color-fg-muted);font-size:12px}.calendar>.days-grid>.day{padding:10px 0;border:1px solid transparent;border-radius:2px;width:var(--day-width);min-width:var(--day-width);max-width:var(--day-width);height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendar>.days-grid>.day:hover{border:1px solid var(--color-fg-primary);color:var(--color-fg-primary)}.calendar>.days-grid>.day.today{color:var(--color-fg-accent)}.calendar>.days-grid>.day.selected{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}@media (max-width: 480px){.container:not(.inline){transform:scaleY(0)!important;transform-origin:bottom center!important}.container:not(.inline).show{position:fixed!important;bottom:0!important;top:auto!important;left:0!important;right:0!important;transform:scaleY(1)!important}.container{width:100%}.calendars{grid-template-columns:repeat(1,1fr)}.calendars .calendar{box-sizing:border-box;width:100%}.calendars .calendar:nth-child(n+2){display:none}.calendars .calendar>.days-grid>.day{width:auto;height:auto;min-width:unset;max-width:unset;min-height:unset;max-height:unset}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}}:host{--color-fg-locked: #9e9e9e;--color-bg-locked: #ffab91;--color-bg-unavailable: #f9f9f9}.container.lock-plugin .calendars .calendar:first-child>.header.no-previous-month .previous-button{visibility:hidden}.container.lock-plugin .calendars .calendar:last-child>.header.no-next-month .next-button{visibility:hidden}.container.lock-plugin .calendar>.days-grid>.day.not-available{pointer-events:none;background-color:var(--color-bg-unavailable);color:var(--color-fg-locked);font-style:italic}.container.lock-plugin .calendar>.days-grid>.day.locked{color:var(--color-fg-locked);background-color:transparent;border:1px solid var(--color-border-locked);pointer-events:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:repeating-linear-gradient(135deg,transparent,var(--color-bg-locked) 2px,transparent 2px,transparent 4px);font-style:italic}.container.lock-plugin .preset-plugin-container>button:disabled{pointer-events:none;color:var(--color-fg-locked)}:host{--color-bg-inrange: #d5dbff;--color-bg-tooltip: #fff;--color-fg-tooltip: #333}.range-plugin-tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:var(--border-radius);background-color:var(--color-bg-tooltip);color:var(--color-fg-tooltip);box-shadow:0 1px 3px #00000040;white-space:nowrap;font-size:12px;pointer-events:none;visibility:hidden;z-index:1}.range-plugin-tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.range-plugin-tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--color-bg-tooltip);border-right:4px solid transparent;border-left:4px solid transparent;content:""}.container.range-plugin .calendar>.days-grid>.day{position:relative}.container.range-plugin .calendar>.days-grid>.day.in-range:last-of-type{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.in-range{border-radius:0;background-color:var(--color-bg-inrange)}.container.range-plugin .calendar>.days-grid>.day.start,.container.range-plugin .calendar>.days-grid>.day.end{background-color:var(--color-fg-primary);color:var(--color-fg-selected)}.container.range-plugin .calendar>.days-grid>.day.start{border-top-right-radius:0;border-bottom-right-radius:0}.container.range-plugin .calendar>.days-grid>.day.start:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-right-color:transparent;right:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.start.flipped{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius);border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.start.flipped:after{right:auto;left:-14px;border-right-color:var(--color-fg-primary);border-left-color:transparent}.container.range-plugin .calendar>.days-grid>.day.end{border-top-left-radius:0;border-bottom-left-radius:0}.container.range-plugin .calendar>.days-grid>.day.end:after{content:"";position:absolute;border:8px solid var(--color-fg-primary);border-top-color:transparent;border-bottom-color:transparent;border-left-color:transparent;left:-14px;z-index:1;pointer-events:none}.container.range-plugin .calendar>.days-grid>.day.end.flipped{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.end.flipped:after{left:auto;right:-14px;border-left-color:var(--color-fg-primary);border-right-color:transparent}.container.range-plugin .calendar>.days-grid>.day.start.end{border-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>.day.start.end:after{content:none}.container.range-plugin .calendar>.days-grid>div:not(.day)+.day.in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n).in-range{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.range-plugin .calendar>.days-grid>div:nth-child(7n+1).in-range{border-top-left-radius:var(--border-radius);border-bottom-left-radius:var(--border-radius)}:host{--color-bg-secondary: var(--gray-50, #f5f5f5);--color-bg-inrange: var(--gray-50, #f5f5f5);--color-fg-default: var(--gray-900, #0a0d12);--color-fg-primary: var(--blue-500, #00b0ff);--color-fg-secondary: var(--gray-300, #a4a7ae);--color-fg-muted: var(--gray-500, #535862);--day-width: 48px;--day-height: 48px;--border-radius: var(--wl-border-radius, 4px)}.container{border-radius:0;font-family:var(--font-roboto, "Roboto"),ui-sans-serif,system-ui,sans-serif;font-size:14px;line-height:1.4}.container.inline{box-shadow:none}@media (min-width: 992px){.container.inline{min-height:440px}}.calendars{padding:24px 0 16px}@media (max-width: 480px){.calendars{padding:8px 0}}.calendars .calendar:nth-child(n+2){display:none}@media (min-width: 992px){.calendars .calendar:nth-child(n+2){display:block}}.calendars .calendar>.days-grid>.day{height:var(--day-height);min-height:var(--day-height);max-height:var(--day-height)}.calendars .calendar:first-child>.header{position:relative}.calendars .calendar:nth-child(2)>.header{position:relative}.calendars .calendar>.header:not(.no-next-month) .next-button{visibility:visible}.calendars.grid-2{grid-template-columns:none}@media (min-width: 992px){.calendars{padding:32px 16px 24px}.calendars.grid-2{grid-template-columns:repeat(2,1fr)}.calendars:not(.grid-1) .calendar>.header .next-button{visibility:hidden}}.calendar{padding:8px 24px}@media (max-width: 480px){.calendar{padding:8px}}.calendar>.header{position:relative;padding:8px 24px}.calendar>.header .month-name{font-weight:700;font-size:14px;text-align:center;text-transform:capitalize}.calendar>.header .month-name>span{font-weight:700}.calendar>.header button{position:absolute;top:5px;padding:0;border:none;border-radius:0}.calendar>.header button.previous-button{left:0}.calendar>.header button.next-button{right:0}.calendar>.header button:hover{background-color:transparent}.calendar>.header button:hover>svg{color:var(--color-fg-default);fill:var(--color-fg-default)}.calendar>.header button>svg{color:var(--color-fg-muted);fill:var(--color-fg-muted);transform:scale(1);height:24px;width:auto}.calendar>.days-grid,.calendar>.daynames-row{row-gap:0;max-width:calc(var(--day-width) * 7);margin:0 auto}.calendar>.days-grid>.day,.calendar>.days-grid>.dayname,.calendar>.daynames-row>.day,.calendar>.daynames-row>.dayname{font-size:14px}.calendar>.daynames-row>.dayname{padding:8px 0;text-transform:capitalize}.calendar>.days-grid>.day{border-radius:var(--border-radius)}.calendar>.days-grid>.day:hover{background-color:var(--color-bg-secondary);border-color:transparent;color:var(--color-fg-default)}.calendar>.days-grid>.day:hover:not(.not-available):not(.locked){cursor:pointer}.calendar>.days-grid>.day.today{color:var(--color-fg-primary)}.calendar>.days-grid>.day.selected.start:not(.flipped):not(.end).single-day{border-top-right-radius:var(--border-radius);border-bottom-right-radius:var(--border-radius)}.container.inline{min-height:unset}.container.range-plugin .calendar>.days-grid>.day.in-range:hover{background-color:var(--color-fg-secondary)}.container.range-plugin .calendar>.days-grid>.day.start:after{content:none}.container.range-plugin .calendar>.days-grid>.day.end:after{content:none}.container.lock-plugin .calendar>.days-grid>.day.not-available{background-color:var(--color-bg-default);font-style:normal}.container.lock-plugin .calendar>.days-grid>.day.not-available.start,.container.lock-plugin .calendar>.days-grid>.day.not-available.end{background-color:var(--color-fg-secondary)}.container.lock-plugin .calendar>.days-grid>.day.locked{background-color:var(--color-bg-default);font-style:normal;border:none}.container.lock-plugin .calendar>.days-grid>.day.locked:not(.start):not(.end){background-image:none;font-style:normal}';
var Q = /* @__PURE__ */ ((i) => (i[i.DISABLED = 0] = "DISABLED", i[i.ENABLED = 1] = "ENABLED", i[i.ONLY_HALF_DAY = 2] = "ONLY_HALF_DAY", i))(Q || {}), F = /* @__PURE__ */ ((i) => (i.ALL_DAY = "day", i.MORNING = "morning", i.AFTERNOON = "afternoon", i.ALL_SEASON = "season", i))(F || {});
function It(i) {
  if (!i.settings.bookingSeasonal && i.settings.bookingHalfDay === Q.DISABLED)
    return null;
  const n = i.dayDifference === 1 && i.settings.bookingHalfDay !== Q.DISABLED;
  return /* @__PURE__ */ k.jsxs("div", { className: "space-y-4 mb-4", children: [
    n ? /* @__PURE__ */ k.jsxs("div", { className: "grid grid-cols-3 gap-2 sm:gap-4", children: [
      /* @__PURE__ */ k.jsx(
        X,
        {
          label: i.labels.all_day,
          onClick: () => {
            i.onButtonClick(F.ALL_DAY);
          },
          active: i.selectedBookingPeriod === F.ALL_DAY
        }
      ),
      /* @__PURE__ */ k.jsx(
        X,
        {
          label: i.labels.morning,
          onClick: () => {
            i.onButtonClick(F.MORNING);
          },
          active: i.selectedBookingPeriod === F.MORNING
        }
      ),
      /* @__PURE__ */ k.jsx(
        X,
        {
          label: i.labels.afternoon,
          onClick: () => {
            i.onButtonClick(F.AFTERNOON);
          },
          active: i.selectedBookingPeriod === F.AFTERNOON
        }
      )
    ] }) : null,
    i.settings.bookingSeasonal ? /* @__PURE__ */ k.jsx(
      X,
      {
        label: i.labels.all_season,
        onClick: () => {
          i.onButtonClick(F.ALL_SEASON);
        }
      }
    ) : null
  ] });
}
function X(i) {
  return /* @__PURE__ */ k.jsx(
    "button",
    {
      type: "button",
      className: ce(
        "block w-full select-none rounded-sm border border-gray-300 bg-white p-2 text-center text-sm text-primary transition-colors hover:border-blue-500 hover:bg-blue-100 hover:text-blue-500 sm:px-3",
        i.className,
        { "bg-blue-100 text-blue-500 border-blue-500": i.active }
      ),
      onClick: i.onClick,
      children: i.label
    }
  );
}
const Bt = [
  new Date(2024, 0, 1),
  // monday
  new Date(2024, 0, 2),
  // tuesday
  new Date(2024, 0, 3),
  // wednesday
  new Date(2024, 0, 4),
  // thursday
  new Date(2024, 0, 5),
  // friday
  new Date(2024, 0, 6),
  // saturday
  new Date(2024, 0, 7)
  // sunday
];
function Je(i) {
  const n = Intl.DateTimeFormat(i.locale, {
    weekday: "short"
  }), e = Intl.DateTimeFormat(i.locale, {
    weekday: "long"
  }), r = Bt.map((a) => ({
    label: n.format(a),
    title: e.format(a)
  }));
  return /* @__PURE__ */ k.jsx("div", { className: "mx-auto my-2 grid w-full max-w-xs grid-cols-7 lg:hidden", children: r.map(({ title: a, label: o }) => /* @__PURE__ */ k.jsx(
    "div",
    {
      className: "text-center text-sm capitalize text-secondary",
      title: a,
      children: o
    },
    a
  )) });
}
function Ht(i) {
  if (!i)
    return 0;
  const n = H.fromJSDate(i.start), e = H.fromJSDate(i.end);
  return Math.floor(e.diff(n, ["days"]).days + 1);
}
function Vt(i, n = !1) {
  return n || !i ? 2 : Math.max(
    Rt({
      start: i.minDate,
      end: i.maxDate
    }),
    2
  );
}
function Kt(i) {
  const {
    settings: n = {
      bookingHalfDay: Q.DISABLED,
      bookingSeasonal: !1
    }
  } = i, [e, r] = T.useState(i.period), { onClick: a, onRender: o, onSelect: c, picker: l, startId: u, endId: h } = jt(r), { formattedPeriod: p } = Ft(i.lang, e), f = Ht(e);
  return T.useEffect(() => {
    const m = document.getElementById(u), M = document.getElementById(h);
    if (!m || !M) {
      console.warn("cannot find startEl or endEl", m, M);
      return;
    }
    const _ = e ? {
      startDate: e.start,
      endDate: e.end
    } : null;
    return l.current = new ze.create({
      element: m,
      css: i.isWidget ? Yt : qe,
      firstDay: 1,
      lang: i.lang,
      format: "YYYY-MM-DD",
      calendars: Vt(i.lockDates, i.isWidget),
      ...i.isWidget ? { grid: 2 } : {},
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [Ot, Ue],
      RangePlugin: {
        elementEnd: M,
        tooltip: !1,
        ..._ ? {
          startDate: new w(_.startDate),
          endDate: new w(_.endDate)
        } : {}
      },
      LockPlugin: {
        inseparable: !0,
        ...i.lockDates ? {
          minDate: i.lockDates.minDate,
          maxDate: i.lockDates.maxDate
        } : {},
        ...i.lockPluginFilter ? { filter: i.lockPluginFilter } : {}
      },
      setup: (j) => {
        j.on("click", a), j.on("render", o), j.on("select", c);
      }
    }), () => {
      l.current && (l.current.off("click", a), l.current.off("render", o), l.current.off("select", c), l.current.destroy(), l.current = null);
    };
  }, []), T.useEffect(() => {
    !l.current || !i.period || (r({
      start: i.period.start,
      end: i.period.end
    }), l.current.setDateRange(i.period.start, i.period.end), l.current.gotoDate(i.period.start));
  }, [i.period]), /* @__PURE__ */ k.jsxs("div", { className: "flex flex-auto flex-col", children: [
    i.isWidget ? null : /* @__PURE__ */ k.jsx(Je, { locale: i.lang }),
    /* @__PURE__ */ k.jsx(
      "div",
      {
        className: ce("flex-auto text-center", { relative: !i.isWidget }),
        children: /* @__PURE__ */ k.jsxs(
          "div",
          {
            className: ce("inset-0 overflow-y-auto lg:static", {
              absolute: !i.isWidget
            }),
            children: [
              /* @__PURE__ */ k.jsx("input", { id: u, type: "hidden" }),
              /* @__PURE__ */ k.jsx("input", { id: h, type: "hidden" })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ k.jsx("div", { className: "relative bg-gray-25 p-4 text-center", children: /* @__PURE__ */ k.jsxs("div", { className: "mx-auto max-w-sm", children: [
      /* @__PURE__ */ k.jsx(
        It,
        {
          dayDifference: f,
          labels: i.labels.bookingPeriod,
          selectedBookingPeriod: i.selectedBookingPeriod ?? null,
          settings: n,
          onButtonClick: (m) => {
            var M;
            (M = i.onChangeBookingPeriod) == null || M.call(i, m);
          }
        }
      ),
      /* @__PURE__ */ k.jsxs("div", { className: "mb-2 capitalize", children: [
        p,
        " ",
        f > 0 && /* @__PURE__ */ k.jsxs("span", { className: "normal-case text-secondary", children: [
          "(",
          f,
          " ",
          f === 1 ? i.labels.day : i.labels.days,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ k.jsx(
        $e,
        {
          type: "button",
          fullWidth: !0,
          onClick: () => {
            var m;
            e && ((m = i.onConfirm) == null || m.call(i, e));
          },
          disabled: !e,
          fontSize: "lg",
          isLoading: i.isLoading,
          children: i.labels.confirmBtn
        }
      )
    ] }) })
  ] });
}
function $t(i, n) {
  const e = /* @__PURE__ */ new Map(), r = i.map(
    (o) => H.fromISO(o.startDate).toSeconds()
  ), a = Array.from(n).map(
    (o) => o / 1e3
  );
  return r.filter((o) => !a.includes(o)).forEach(
    (o) => e.set(Ie(o), "removed")
  ), a.filter((o) => !r.includes(o)).forEach((o) => e.set(Ie(o), "added")), e;
}
function Ie(i) {
  return H.fromSeconds(i).toISODate();
}
const Be = "share-date-picker", de = "absence", He = "sold";
function Zt(i) {
  const n = T.useRef(null), e = T.useRef(/* @__PURE__ */ new Set()), r = T.useRef(
    i.daysSold.map((h) => H.fromISO(h).toMillis())
  ), [a, o] = T.useState(!1), c = T.useCallback((h) => {
    if (h.detail.view !== "Container")
      return;
    const p = h.target;
    r.current.forEach((f) => {
      const m = p.querySelector(
        `.day.unit[data-time="${f}"]`
      );
      m && m.classList.add(He);
    }), p.querySelectorAll(`.day.${de}`).forEach((f) => f.classList.remove(de)), e.current.forEach((f) => {
      const m = p.querySelector(
        `.day.unit[data-time="${f}"]`
      );
      m && m.classList.add(de);
    });
  }, []), l = T.useCallback(
    (h) => {
      var M;
      if (!h.target)
        return;
      const p = h.target, f = h.detail.date.getTime(), m = p.querySelector(
        `.day.unit[data-time="${f}"]`
      );
      m && (m.classList.contains(He) || (e.current.has(f) ? e.current.delete(f) : e.current.add(f), (M = n.current) == null || M.clear()));
    },
    []
  );
  T.useEffect(() => {
    var f;
    e.current = new Set(
      i.absences.map((m) => H.fromISO(m.startDate).toMillis())
    );
    const h = document.getElementById(Be);
    if (!h)
      return;
    const p = {
      LockPlugin: {
        inseparable: !0,
        minDate: i.reservation.startDate,
        maxDate: i.reservation.endDate
      }
    };
    return n.current = new ze.create({
      element: h,
      css: qe,
      firstDay: 1,
      lang: i.lang,
      format: "YYYY-MM-DD",
      calendars: i.calendars,
      inline: !0,
      locale: {
        previousMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2898 11.9999L14.8298 8.45995C15.0161 8.27259 15.1206 8.01913 15.1206 7.75495C15.1206 7.49076 15.0161 7.23731 14.8298 7.04995C14.7369 6.95622 14.6263 6.88183 14.5044 6.83106C14.3825 6.78029 14.2518 6.75415 14.1198 6.75415C13.9878 6.75415 13.8571 6.78029 13.7352 6.83106C13.6134 6.88183 13.5028 6.95622 13.4098 7.04995L9.16982 11.2899C9.07609 11.3829 9.0017 11.4935 8.95093 11.6154C8.90016 11.7372 8.87402 11.8679 8.87402 11.9999C8.87402 12.132 8.90016 12.2627 8.95093 12.3845C9.0017 12.5064 9.07609 12.617 9.16982 12.7099L13.4098 16.9999C13.5033 17.0926 13.6141 17.166 13.7359 17.2157C13.8578 17.2655 13.9882 17.2907 14.1198 17.2899C14.2514 17.2907 14.3819 17.2655 14.5037 17.2157C14.6256 17.166 14.7364 17.0926 14.8298 16.9999C15.0161 16.8126 15.1206 16.5591 15.1206 16.2949C15.1206 16.0308 15.0161 15.7773 14.8298 15.5899L11.2898 11.9999Z"/></svg>',
        nextMonth: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.8297 11.2899L10.5897 7.04995C10.4967 6.95622 10.3861 6.88183 10.2643 6.83106C10.1424 6.78029 10.0117 6.75415 9.8797 6.75415C9.74769 6.75415 9.61698 6.78029 9.49512 6.83106C9.37326 6.88183 9.26266 6.95622 9.1697 7.04995C8.98345 7.23731 8.87891 7.49076 8.87891 7.75495C8.87891 8.01913 8.98345 8.27259 9.1697 8.45995L12.7097 11.9999L9.1697 15.5399C8.98345 15.7273 8.87891 15.9808 8.87891 16.2449C8.87891 16.5091 8.98345 16.7626 9.1697 16.9499C9.26314 17.0426 9.37395 17.116 9.49579 17.1657C9.61763 17.2155 9.74809 17.2407 9.8797 17.2399C10.0113 17.2407 10.1418 17.2155 10.2636 17.1657C10.3854 17.116 10.4963 17.0426 10.5897 16.9499L14.8297 12.7099C14.9234 12.617 14.9978 12.5064 15.0486 12.3845C15.0994 12.2627 15.1255 12.132 15.1255 11.9999C15.1255 11.8679 15.0994 11.7372 15.0486 11.6154C14.9978 11.4935 14.9234 11.3829 14.8297 11.2899Z"/></svg>'
      },
      plugins: [Ue],
      setup(m) {
        m.on("render", c), m.on("select", l);
      },
      ...p
    }), (f = n.current) == null || f.gotoDate(i.reservation.startDate), () => {
      n.current && (n.current.off("render", c), n.current.off("select", l), n.current.destroy(), n.current = null, e.current = /* @__PURE__ */ new Set());
    };
  }, []);
  async function u() {
    try {
      const h = $t(i.absences, e.current);
      if (h.size === 0)
        return;
      o(!0), await i.saveSharingChanges(h);
    } finally {
      o(!1), i.onCloseDialog();
    }
  }
  return /* @__PURE__ */ k.jsxs("div", { className: "flex flex-auto flex-col", children: [
    /* @__PURE__ */ k.jsx(Je, { locale: i.lang }),
    /* @__PURE__ */ k.jsx("div", { className: "relative flex-auto text-center", children: /* @__PURE__ */ k.jsx("div", { className: "absolute inset-0 overflow-y-auto lg:static", children: /* @__PURE__ */ k.jsx("input", { id: Be, type: "hidden" }) }) }),
    /* @__PURE__ */ k.jsx("div", { className: "relative bg-gray-50 p-4 text-center", children: /* @__PURE__ */ k.jsx(
      $e,
      {
        fullWidth: !0,
        type: "button",
        onClick: u,
        disabled: a,
        children: i.buttonLabel
      }
    ) })
  ] });
}
export {
  Q as BookingHalfDay,
  F as BookingPeriod,
  Kt as DatePicker,
  Je as DatePickerHeader,
  Zt as SharingDatePicker,
  Rt as getCalendarsByPeriod,
  Tt as isSameDay,
  jt as useDatePicker,
  Ft as useFormattedPeriod
};
